import { USAGE_GUIDELINES_URL } from '../../../config/fullexperience';
import styles from './ChatFooter.module.css';

export interface ChatFooterProps {
  /** Show the built-in usage guidelines disclaimer. Defaults to true. */
  showUsageGuidelines?: boolean;
  /** Optional extra text appended after the usage guidelines line (e.g. app name or version). */
  footerText?: string;
  variant?: 'default' | 'compact' | 'floating';
  onClearHistory?: () => void;
  showClearHistory?: boolean;
  className?: string;
}

export function ChatFooter({
  showUsageGuidelines = true,
  footerText,
  variant = 'default',
  onClearHistory,
  showClearHistory = false,
  className = '',
}: ChatFooterProps) {
  const hasContent = showUsageGuidelines || footerText;

  if (!hasContent && !showClearHistory) return null;

  return (
    <footer className={`${styles.footer} ${styles[variant]} ${className}`}>
      {showClearHistory && onClearHistory && (
        <div className={styles.actions}>
          <button className={styles.button} onClick={onClearHistory}>
            Clear history
          </button>
        </div>
      )}
      {hasContent && (
        <p className={styles.disclaimer}>
          {footerText && <div>{footerText}</div>}
          {showUsageGuidelines && (
            <>
              {'AI\u2011generated content may be incorrect \u2011 please follow '}
              <a
                href={USAGE_GUIDELINES_URL}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                usage guidelines
              </a>
            </>
          )}
          
          
        </p>
      )}
    </footer>
  );
}
